import { HorizontalView } from "_components/Abstractions/HorizontalView";
import { FormControl } from "_components/Forms/FormControl";
import { ReadonlyControl } from "_components/Forms/ReadonlyControl";
import { useFormContext } from "react-hook-form";
import { DomainButton } from "../../../../_components/Abstractions/DomainButton";
import { ExternalWeighingContractorSelect } from "./ExternalWeighingContractorSelect";
import { ListGroup } from "react-bootstrap";
import { AccordionDomain } from "../../../../_components/Abstractions/AccordionDomain";

export function ContractorIntegrationDetailsForm() {
  const { watch, setValue } = useFormContext();
  const externalWeighingLinks = watch("externalWeighingLinks");

  const setValueOptions = {
    shouldValidate: true,
    shouldDirty: true,
    shouldTouch: true
  };

  const onExternalWeighingContractorSelect = (selectedItems) => {
    const links = selectedItems.map(contractor => ({
      id: contractor.id?.toString(),
      name: contractor.name
    }));
    setValue("externalWeighingLinks", links, setValueOptions);
  };

  const removeExternalWeighingLink = () => {
    setValue("externalWeighingLinks", [], setValueOptions);
  };

  return (
    <div>
      <AccordionDomain header="Program wagowy">
        <div className="mb-2">
          <ExternalWeighingContractorSelect
            onSelect={onExternalWeighingContractorSelect}
            multiple={true}
            defaultValues={externalWeighingLinks ?? []}
          />
        </div>
        <div>
          {externalWeighingLinks && externalWeighingLinks.length > 0 && (
            <ListGroup className="my-2">
              {externalWeighingLinks?.map((x, idx) =>
                <ListGroup.Item key={x.id}>
                  {externalWeighingLinks.length > 1 && `${idx + 1}.`} <b>{x.name}</b>
                </ListGroup.Item>)}
            </ListGroup>
            // <ReadonlyControl label="Program wagowy">
            //   {externalWeighingLinks.map(link => link.name).join(", ")}
            // </ReadonlyControl>
          )}
        </div>
      </AccordionDomain>
      <div className="mt-2">
        <FormControl label="Program magazynowy" name="externalName" required={false}/>
      </div>
    </div>
  );
}
